module.exports = __webpack_public_path__ + "static/media/Unirac_Logo_Blue.a20fb3e5.png";